import { I18n } from "@shared/modules/utils/LangUtil";
import moment from "moment";
import React from "react";

const AccountBlock = ({ data = {} }) => {
    const { onClickYes = () => {}, onClickNo = () => {}} = data.events || {};
    const {status={} } = data || {};
    return (
        <div className="typical-popup">
            <h5 style={{ textAlign: "center" }}>
                <strong>{I18n("g.lbl.info")}</strong>
            </h5>
            <div dangerouslySetInnerHTML={{__html : I18n(`g.msg.account_block`)}} style={{display:"block"}} />

           
            <div style={{ margin: "0 auto", width: "426px" , padding:0}}>
                <button className="btn btn-success" onClick={onClickNo}>
                    {I18n("g.lbl.ok")}
                </button>
            </div>
        </div>
    );
};

export default AccountBlock;
